import {Highlighter, React, observer} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {useStores} from '@modules'
import {ICatalogSearchResult} from './CatalogSearchTypes'

import * as css from './CatalogSearchGroupHeader.css'

export const CatalogSearchGroupHeader = observer<{ item: ICatalogSearchResult}>(function CatalogSearchGroupHeader({item: {groupLabel}}) {
  const {
      catalog: {
        searcher: {searchWords}
      }
    } = useStores()

    return (groupLabel ? <MenuDivider className={css.root} title={
        <div className={css.title}>
          <Highlighter textToHighlight={groupLabel}
                       autoEscape
                       searchWords={searchWords}/>
        </div>
      }/> : null
    )
})


// WEBPACK FOOTER //
// ./src/modules/catalogSearcher/CatalogSearchGroupHeader.tsx